import { GamstopUserStore } from './Gamstop.store';
import { Common } from 'src/AppState/Common';
import { makeObservable } from 'mobx';

export class GamstopState {
    public gamstopUserStore: GamstopUserStore;

    public constructor(
        private readonly customerId: number,
        private readonly common: Common
    ) {
        makeObservable(this);
        this.gamstopUserStore = new GamstopUserStore(this.common, this.customerId);
    }
}
